import { call, options, params } from './helpers';

export const getDocument = ({ id }) => call(`/beta/documents/${id}`);
export const getDocuments = (payload) => {
	return call(`/beta/documents${params(payload)}`);
};
export const uploadDocument = (payload) =>
	call(`/beta/documents`, options(payload, 'POST'));

export const updateDocument = ({ id, ...payload }) =>
	call(`/beta/documents/${id}`, options(payload, 'PUT'));

export const uploadDocumentBeta = (payload) =>
	call(`/beta/documents/upload`, options(payload, 'POST'));

export const deleteDocument = ({ id }) =>
	call(`/beta/documents/${id}`, options(null, 'DELETE'));
